// data/items/petMaterials.js
// Pet awakening and crafting materials from Gatherer skill

export const PET_MATERIALS = [
    // Tier 1 - Basic awakening material
    {
        id: 'twisted_root_fiber',
        name: 'Twisted Root Fiber',
        color: '#6b4423',
        tier: 1,
        description: 'Fibrous strands from enchanted roots, used for basic pet awakening.',
        value: 30
    },
    // Tier 2 - Intermediate awakening material
    {
        id: 'living_arcane_husk',
        name: 'Living Arcane Husk',
        color: '#4a7c59',
        tier: 2,
        description: 'A semi-sentient shell pulsing with latent energy.',
        value: 125
    },
    // Tier 3 - Advanced awakening material
    {
        id: 'condensed_arcane_core_fragment',
        name: 'Condensed Arcane Core Fragment',
        color: '#8a2be2',
        tier: 3,
        description: 'Crystallized essence from the heart of unstable growths.',
        value: 295
    }
];

export default PET_MATERIALS;
